import React from 'react';
import Page from '../../shared/components/Page';

import AppContentContainer, { AppsUnselected } from '../components/AppsContent';
import AppsSidebarContainer from '../components/AppsSidebar';

const AppCreate = (props) => {
    return (
        <Page>
            <Page.Sidebar>
                <AppsSidebarContainer {...props} />
            </Page.Sidebar>
            <Page.MainArea>
                <AppContentContainer {...props} />
            </Page.MainArea>
        </Page>
    )
}

export const AppUnselected = (props) => {
    return (
        <Page>
            <Page.Sidebar>
                <AppsSidebarContainer {...props} />
            </Page.Sidebar>
            <Page.MainArea>
                <AppsUnselected />
            </Page.MainArea>
        </Page>
    )
}

export default AppCreate;


// WEBPACK FOOTER //
// ./src/apps/pages/AppContent.js